import { createApp } from 'vue'
import App from '@/App'
import VueTippy from 'vue-tippy'
import VClickOutside from 'click-outside-vue3'
import Notifications from '@kyvg/vue3-notification'
import router from '@/routes'
import store from '@/store'

createApp(App)
    .use(router)
    .use(store)
    .use(VClickOutside)
    .use(Notifications)
    .use(
        VueTippy,
        {
            directive: 'tippy', // => v-tippy
            component: 'tippy', // => <tippy/>
            componentSingleton: 'tippy-singleton', // => <tippy-singleton/>,
            defaultProps: {
                theme: 'custom',
                placement: 'auto-end',
                allowHTML: true,
                delay: 0,
                arrow: false,
                hideOnClick: false,
                // trigger: 'click',
                offset: [0, 12],
                maxWidth: 'none',
            },
        }
    )
    .mount('#app')
